import type { Text } from 'generated/graphql';

const locale = 'en';

export default (textOptions: Text[]): string =>
  textOptions.find((name) => name.locale === locale)?.text ??
  textOptions[0]?.text ??
  '';
